import { Button } from "./ui/button";

const Cards = ({ image, title, description, buttonText, onGetQuote }) => {
  return (
    <div className="service-card">
      <div className="card-img">
        <img src={image} alt={title || "Service image"} loading="lazy" />
      </div>
      <div className="card-content user-select-none">
        <div className="card-heading">
          <h3>{title}</h3>
        </div>
        <div className="card-text">
          <p>{description}</p>
        </div>
        {buttonText && (
          <div className="card-button">
            <Button size="sm" variant="outline" onClick={onGetQuote}>
              {buttonText}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
export default Cards;
